import * as mutation from "./mutations-types";

export default {
  [mutation.SET_NAME](state, name) {
    state.name = name;
  },

  [mutation.SET_ROLE](state, role) {
    state.role = role;
  },
  [mutation.SET_LOGIN](state, login) {
    state.login = login;
  },
  [mutation.SET_FULL_NAME](state, fullName) {
    state.fullName = fullName;
  },
  [mutation.SET_ID](state, id) {
    state.id = id;
  },
  resetState(state) {
    state.role = null;
    state.name = null;
    state.login = null;
    state.fullName = null;
    state.id = null;
  }
};
